// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c17c6d7f","83":"8b57d46e","233":"f2b5d98b","660":"f3b8a700","774":"e535cbc7","823":"0ca2e9f2","842":"a0ec9c0e","957":"5a97e09d","999":"bbf61d25"}[chunkId] + ".chunk.js";
};